import { cn } from '../../utils/index';

interface ProgressBarProps {
  progress: number; // 0-100
  containerClassName?: string;
  barClassName?: string;
}

export function ProgressBar({ progress, containerClassName, barClassName }: ProgressBarProps) {
  return (
    <div className={cn('flex h-4 w-full items-center', containerClassName)}>
      <div className="bg-secondary relative h-full w-full overflow-hidden rounded-full">
        <div
          className={cn('h-full transition-all duration-300', barClassName)}
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
    </div>
  );
}
